import * as React from "react";
import type { SVGProps } from "react";
const SvgEarnestMoneyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20 6.34a.381.381 0 0 0-.298-.364L12.224 4.03a.89.89 0 0 0-.448 0L4.298 5.976A.382.382 0 0 0 4 6.341c.008 1.251.064 2.77.248 4.19.184 1.421.495 2.739 1.01 3.596 1.862 3.104 4.736 4.602 6.405 5.457h.002l.335.173c.241-.119.531-.24.783-.344l.037-.016c1.725-.718 4.502-1.908 5.982-5.262.896-2.031 1.175-5.316 1.198-7.794Zm-7.12 15.214-.903.446-.892-.465-.334-.171c-1.684-.863-5.029-2.575-7.209-6.208-.738-1.231-1.087-2.9-1.277-4.368C2.066 9.253 2.008 7.644 2 6.354A2.382 2.382 0 0 1 3.794 4.04l7.478-1.948a2.89 2.89 0 0 1 1.456 0l7.478 1.948A2.38 2.38 0 0 1 22 6.359c-.023 2.493-.292 6.144-1.368 8.583-1.82 4.126-5.277 5.566-7.042 6.301-.286.12-.528.22-.71.31ZM12 5.25a1 1 0 0 1 1 1v.875h.969a1 1 0 0 1 0 2h-2.953c-.161 0-.321.065-.444.191a.712.712 0 0 0-.197.496c0 .192.074.37.197.497a.618.618 0 0 0 .444.191h1.968c.71 0 1.385.29 1.877.797.492.506.764 1.187.764 1.89 0 .704-.272 1.385-.764 1.89a2.618 2.618 0 0 1-1.861.798v.875a1 1 0 1 1-2 0v-.875h-.969a1 1 0 0 1 0-2h2.953c.161 0 .321-.065.444-.191a.712.712 0 0 0 .197-.496.712.712 0 0 0-.197-.497.618.618 0 0 0-.444-.191h-1.968c-.71 0-1.385-.29-1.877-.797a2.712 2.712 0 0 1-.764-1.89c0-.704.272-1.385.764-1.89A2.618 2.618 0 0 1 11 7.124V6.25a1 1 0 0 1 1-1Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgEarnestMoneyIcon;
